@import '~less/bootstrap/legacy-mixins';

/**
 * Fontello icon font
 *
 * Read more: modules/core/client/fonts/fontello/README.md
 */

// Cache buster
@icon-version: '2017-08-16';
@icon-li-width: (30em / 14);

@font-face {
  font-family: 'tricons';
  src: url('~modules/core/client/fonts/fontello/font/tricons.eot?v=@{icon-version}');
  src:
    url('~modules/core/client/fonts/fontello/font/tricons.eot?v=@{icon-version}#iefix')
      format('embedded-opentype'),
    url('~modules/core/client/fonts/fontello/font/tricons.woff?v=@{icon-version}')
      format('woff'),
    url('~modules/core/client/fonts/fontello/font/tricons.ttf?v=@{icon-version}')
      format('truetype'),
    url('~modules/core/client/fonts/fontello/font/tricons.svg?v=@{icon-version}#tricons')
      format('svg');
  font-weight: normal;
  font-style: normal;
}
/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
/*
@media screen and (-webkit-min-device-pixel-ratio:0) {
  @font-face {
    font-family: 'tricons';
    src: url('/modules/core/fonts/fontello/font/tricons.svg#tricons') format('svg');
  }
}
*/

// Leaflet attribution control i-symbol
// See leaflet.less for more
.leaflet-container .leaflet-control-attribution:after,
// Original Fontello CSS
[class^="icon-"]:before, [class*=" icon-"]:before {
  font-family: 'tricons';
  font-style: normal;
  font-weight: normal;
  speak: none;

  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  /* opacity: .8; */

  /* For safety - reset parent styles, that can break glyph codes*/
  font-variant: normal;
  text-transform: none;

  /* text-rendering:optimizelegibility would throw things off */
  text-rendering: auto;

  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;

  /* Animation center compensation - margins should be symmetric */
  /* remove if not needed */
  margin-left: 0.2em;

  /* you can be more comfortable with increased icons size */
  /* font-size: 120%; */

  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */

  /* Ensures no half-pixel rendering in firefox */
  transform: translate(0, 0);
}

// Icon Sizes
// Adapted from FontAwesome - MIT licensed
// @link http://opensource.org/licenses/mit-license.html
// @link https://github.com/FortAwesome/Font-Awesome/blob/master/less/larger.less
// -------------------------

/* makes the font 33% larger relative to the icon container */
.icon-lg {
  font-size: (4em / 3);
  line-height: (3em / 4);
  vertical-align: -15%;
}
.icon-2x {
  font-size: 2em;
}
.icon-3x {
  font-size: 3em;
}
.icon-4x {
  font-size: 4em;
}
.icon-5x {
  font-size: 5em;
}

// List Icons
// CSS adapted from FontAwesome - MIT licensed
// @link http://opensource.org/licenses/mit-license.html
// @link https://github.com/FortAwesome/Font-Awesome/blob/master/less/list.less
// -------------------------

.icon-ul {
  padding-left: 0;
  margin-left: @icon-li-width;
  list-style-type: none;
  > li {
    position: relative;
  }
}
.icon-li {
  position: absolute;
  left: -@icon-li-width;
  width: @icon-li-width;
  top: (2em / 14);
  text-align: center;
  &.icon-lg {
    left: (-@icon-li-width + (4em / 14));
  }
}

// Fixed Width Icons
// Adapted from FontAwesome - MIT licensed
// @link http://opensource.org/licenses/mit-license.html
// @link https://github.com/FortAwesome/Font-Awesome/blob/master/less/fixed-width.less
// -------------------------
.icon-fw {
  width: (18em / 14);
  text-align: center;
}

// Leaflet attribution i-symbol
.leaflet-container .leaflet-control-attribution:after {
  content: '\e82d';
}

// Colorful hospitality network icons (nothing to do with fonts otherwise but we use the same .icon- base class).
.icon-couchers,
.icon-bw,
.icon-cs {
  &:before {
    content: '';
    min-height: 1em;
    min-width: 1em;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 16px 16px;
  }
}

.icon-couchers:before {
  .img-retina('~img/external/icon-couchers.png', '~img/external/icon-couchers@2x.png', 16px, 16px);
}
.icon-bw:before {
  .img-retina('~img/external/icon-bw.png', '~img/external/icon-bw@2x.png', 16px, 16px);
}
.icon-cs:before {
  .img-retina('~img/external/icon-cs.png', '~img/external/icon-cs@2x.png', 16px, 16px);
}

.btn .icon {
  margin-right: 5px;
}
